import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';

interface Props {
  onClick: () => void;
  isError: boolean;
}
export const ExtractedDataErrorButton = ({ onClick, isError }: Props) => {
  const { t } = useTranslation();

  const styles = `flex text-foreground rounded-r-[6px] rounded-l-none border border-l-0 border-border shadow-[0_1px_2px_0_rgba(0,0,0,0.10)] flex-1 transition-colors ${
    isError ? 'bg-red-4 hover:bg-red-4' : 'bg-muted hover:bg-red-4'
  }`;

  return (
    <Button onClick={onClick} className={styles}>
      <X className="w-4 h-4 text-red-600" />
      <span className="text-sm font-medium">{t('coverage.errorDetected')}</span>
    </Button>
  );
};
